import { lazyGetSnoozeSections } from "owa-mail-ribbon-sections/lib/sections";
import { setMenuDefinition } from "../../mutatorActions/setMenuDefinition";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";

export const onSnoozeMenuClicked = (props: ReadOnlyRibbonControlDefProps): void => {
    lazyGetSnoozeSections.import().then(getSnoozeSections => {
        setMenuDefinition("SnoozeMenuDefinitionStore", props.projectionTabId /* projectionTabId */, () => {
            return {
                sections: getSnoozeSections(props),
            };
        });
    });
};
